import { Form } from '@/helpers/Form';
import Pager from '@/helpers/Pager';

export default {
    namespaced: true,
    state: {
        filter: Form.create({
            searchText: '',
            organizationId: -1,
            showInactive: false,
            showUnitsBelow: true
        }),
        pager: new Pager(1, 50, 'Id', 'ASC')
    }
};
